import type {
  CardIssuerCreateRequest,
  CardIssuerResponse,
  CardIssuerUpdateRequest,
  CardIssuerListResponse,
} from '../types';
import type { RequestFn } from '../../client';

export class CardIssuers {
  constructor(private readonly request: RequestFn) {}

  async create(params: CardIssuerCreateRequest): Promise<CardIssuerResponse> {
    return this.request('POST', '/card-issuers', { body: params });
  }

  async update(issuerId: string, params: CardIssuerUpdateRequest): Promise<CardIssuerResponse> {
    return this.request('PUT', `/card-issuers/${encodeURIComponent(issuerId)}`, { body: params });
  }

  async list(): Promise<CardIssuerListResponse> {
    return this.request('GET', '/card-issuers');
  }
}
